
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoItem3Grid extends Serenity.EntityGrid<PsAdvPromoItem3Row, any> {
        protected getColumnsKey() { return PsAdvPromoItem3Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoItem3Dialog; }
        protected getIdProperty() { return PsAdvPromoItem3Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoItem3Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoItem3Row.localTextPrefix; }
        protected getService() { return PsAdvPromoItem3Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}